module.exports = __webpack_public_path__ + "static/media/display-suite-05.e42fc6c3.jpg";